<template>
  <div
    v-if="!isPremium"
    class="ad-smp mb-2"
  >
    <div ref="ads" />
    <!--   <Adsense
         data-ad-client="ca-pub-5152865430457107"
         data-ad-slot="8539426925"
       />-->
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'AdSmp',
  components: {},
  computed: {
    ...mapState({
      isPremium: state => state.userModule.isPremium
    })
  },
  data() {
    return {
      scriptText:
          "<script src=\"//i.socdm.com/sdk/js/adg-script-loader.js?id=123822&targetID=adg_123822&displayid=1&adType=SP&async=false&tagver=2.0.0\"><\/script>"
    }
  },
  async mounted() {
    if (!this.isPremium) {
      const iframe1 = document.createElement('iframe');
      iframe1.setAttribute("frameborder", "0")
      iframe1.setAttribute("width", "320")
      iframe1.setAttribute("height", "50")
      this.$refs.ads.appendChild(iframe1);
      const html = `<body>${this.scriptText}<\/body>`;
      const iframeDocument = iframe1.contentWindow.document;
      iframeDocument.open();
      iframeDocument.write(html);
      iframeDocument.close();
    }
  },
  methods: {}
}
</script>

<style>
.ad-smp {
  width: 100%;
  height: 60px;
}

/* 画面サイズの横幅が 768px より大きい場合に適用 */
@media screen and (min-width: 960px) {
  .ad-smp {
    display: none;
  }
}

/* 画面サイズの横幅が小さい場合に適用 */
@media screen and (max-width: 960px) {
  .ad-smp {
    display: block;
  }
}
</style>
